import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Sidebar from '../../Navigation/Sidebar/Sidebar';
import leftArrow from "../../../assests/leftArrow.svg";
import searchIcon from "../../../assests/search.svg";
import editIcon from "../../../assests/bosEdit.svg";
import deleteIcon from "../../../assests/deleteIcon.svg";
import { toastr } from 'react-redux-toastr';
import './SubCategoryList.css';

const SubCategoryListComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const category = location.state?.categoryData;
  
  const [searchTerm, setSearchTerm] = useState('');
  const [subCategories, setSubCategories] = useState(category?.subCategories || []);

  if (!category) {
    return (
      <div className="subcategory-container">
        <Sidebar />
        <div className="subcategory-content">
          <div className="error-state">
            <p>Category not found</p>
            <button onClick={() => navigate(-1)}>Go Back</button>
          </div>
        </div>
      </div>
    );
  }

  // Filter subcategories based on search
  const filteredSubCategories = subCategories.filter(sub =>
    sub.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Handle add subcategory
  const handleAddSubCategory = () => {
    navigate(`/home/product/categories/subcategories/create/${category.id}`, {
      state: { categoryData: category }
    });
  };

  // Handle edit subcategory
  const handleEditSubCategory = (e, subCategory) => {
    e.stopPropagation();
    navigate(`/home/product/categories/subcategories/edit/${subCategory.id}`, {
      state: { categoryData: category, subCategoryData: subCategory }
    });
  };

  // Handle delete subcategory
  const handleDeleteSubCategory = (e, subCategory) => {
    e.stopPropagation();
    if (window.confirm(`Are you sure you want to delete "${subCategory.name}"?`)) {
      const updatedSubCategories = subCategories.filter(sub => sub.id !== subCategory.id);
      setSubCategories(updatedSubCategories);
      toastr.success("Success", "Sub category deleted successfully!");
    }
  };

  return (
    <div className="subcategory-container">
      <Sidebar />
      
      <div className="subcategory-content">
        {/* Header */}
        <div className="subcategory-header">
          <button className="subcategory-back-btn" onClick={() => navigate(-1)}>
            ←
          </button>
          <div>
            <h1>Sub Categories</h1>
            <div className="parent-category-badge">
              Parent Category: {category.name}
            </div>
          </div>
        </div>

        {/* Search Section */}
        <div className="subcategory-search-section">
          <div className="subcategory-search-wrapper">
            <img src={searchIcon} alt="search" className="subcategory-search-icon" />
            <input
              type="text"
              placeholder="Search Sub Category..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="subcategory-search-input"
            />
          </div>
        </div>

        {/* Sub Categories Grid */}
        <div className="subcategory-grid">
          {/* Add Sub Category Card */}
          <div className="subcategory-card create-subcard" onClick={handleAddSubCategory}>
            <div className="create-subcard-content">
              <div className="plus-icon-wrapper-sub">
                <span className="plus-icon-sub">+</span>
              </div>
              <span className="create-subcard-text">Add Sub Category</span>
            </div>
          </div>

          {/* Existing Sub Categories */}
          {filteredSubCategories.length > 0 ? (
            filteredSubCategories.map((subCategory) => (
              <div key={subCategory.id} className="subcategory-card">
                <div className="subcategory-card-actions">
                  <button 
                    className="sub-action-icon sub-edit-icon"
                    onClick={(e) => handleEditSubCategory(e, subCategory)}
                    title="Edit"
                  >
                    <img src={editIcon} alt="Edit" />
                  </button>
                  <button 
                    className="sub-action-icon sub-delete-icon"
                    onClick={(e) => handleDeleteSubCategory(e, subCategory)}
                    title="Delete"
                  >
                    <img src={deleteIcon} alt="Delete" />
                  </button>
                </div>
                <div className="subcategory-card-image">
                  <img 
                    src={subCategory.image_url || subCategory.image || 
                      "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&h=400&fit=crop"
                    } 
                    alt={subCategory.name}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&h=400&fit=crop";
                    }}
                  />
                </div>
                <div className="subcategory-card-name">{subCategory.name}</div>
                <div className="subcategory-card-status">
                  <span className={`sub-status-badge ${subCategory.status === 'active' ? 'sub-status-active' : 'sub-status-inactive'}`}>
                    {subCategory.status === 'active' ? 'ACTIVE' : 'INACTIVE'}
                  </span>
                </div>
              </div>
            ))
          ) : (
           
              <div className="no-subcategories">
                <div className="no-data-icon">📁</div>
                <p>No sub categories found</p>
                {searchTerm && <small>Try a different search term</small>}
              </div>
            
          )}
        </div>
      </div>
    </div>
  );
};

export default SubCategoryListComponent;